export default __webpack_public_path__ + "static/content-51f38231961e160acc994b0660db8a79.jpg";